import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'
export type PostProductionLine = {
  productName: string
  qty: number
  source: 'plan' | 'off_plan'
}

export type PostProductionRequest = {
  sessionRef: string
  deviceId: string
  pin: string
  lines: PostProductionLine[]
  note?: string
}

export type PostProductionResponse = {
  posted_at: string
}

const DEV_PIN = '123456'

function useMockApi(): boolean {
  return isMockApi
}

function mockPostProduction(req: PostProductionRequest): PostProductionResponse {
  if (req.pin !== DEV_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }

  const hasQty = req.lines.some((line) => line.qty > 0 && line.productName.trim())
  if (!hasQty) {
    throw new Error('Minimal 1 produk dengan jumlah lebih dari 0.')
  }

  return { posted_at: new Date().toISOString() }
}

export async function postProductionSessionDirect(
  req: PostProductionRequest,
): Promise<PostProductionResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockPostProduction(req)
  }

  return apiFetch<PostProductionResponse>(`/kitchen/production-sessions/${req.sessionRef}/post`, {
    method: 'POST',
    body: JSON.stringify({
      device_id: req.deviceId,
      pin: req.pin,
      lines: req.lines,
      note: req.note,
    }),
  })
}

export async function postProductionSession(req: PostProductionRequest): Promise<PostProductionResponse> {
  return runKitchenSync(
    {
      type: 'production_post',
      label: `Masuk stok ${req.sessionRef}`,
      payload: req,
    },
    () => postProductionSessionDirect(req),
    () => ({ posted_at: new Date().toISOString() }),
  )
}
